import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_BRAND_SETTINGS_BY_ORGANIZATION_ID } from "../graphql/queries/paymentlink";
import { useSelector } from "react-redux";
import { RootState } from "../store/rootReducer";
import { EnumType } from "typescript";

export interface BrandSettingsDetails {
  Heading1fontSizes?: string;
  primaryColor?: string;
  secondaryColor?: string;
  primaryLogo?: string;
  whiteBackgroundLogo?: string;
  Heading1fontStyle?: string;
  Heading2fontStyle?: string;
  Heading2fontSizes?: string;
  SubHeadingfontStyle?: string;
  SubHeadingfontSizes?: string;
  companyName?: string;
  companyDescription?: string;
  keywords?: string;
  emailTemplates?: string;
  customCss?: string;
  meta?: string;
  socialMediaLinks?: string[];
  backgroundImages?: string[];
  headerImages?: string[];
  legalInformation?: string[];
  status?: EnumType;
}

const useBrandSettings = (organizationId: string) => {
  const [brandSettings, setBrandSettings] = useState(null);

  const { loading, error, data } = useQuery(
    GET_BRAND_SETTINGS_BY_ORGANIZATION_ID,
    {
      variables: { service: "payment-link", input: { organizationId } },
    }
  );

  useEffect(() => {
    if (data) {
      setBrandSettings(data.getAdvanceBrandSettingsByOrganizationId);
    }
  }, [data]);

  return { loading, error, brandSettings };
};

export default useBrandSettings;
